export const environment = {
  production: true,
  version: '37105cd24b',
  site_version: 'SITE_VERSION'
};
